import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permanent-address',
  templateUrl: './permanent-address.component.html',
  styleUrls: ['./permanent-address.component.css']
})
export class PermanentAddressComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'image', url: 'assets/projects/PermanentAddress/1.jpg', title: '1.jpg' },
    { id: 2, type: 'image', url: 'assets/projects/PermanentAddress/2.jpg', title: '2.jpg' },
    { id: 3, type: 'image', url: 'assets/projects/PermanentAddress/3.jpg', title: '3.jpg' },
    { id: 4, type: 'image', url: 'assets/projects/PermanentAddress/4.jpg', title: '4.jpg' },
    { id: 5, type: 'image', url: 'assets/projects/PermanentAddress/5.jpg', title: '5.jpg' },
    { id: 6, type: 'image', url: 'assets/projects/PermanentAddress/6.jpg', title: '6.jpg' },
    { id: 7, type: 'image', url: 'assets/projects/PermanentAddress/7.jpg', title: '7.jpg' },
    { id: 8, type: 'image', url: 'assets/projects/PermanentAddress/8.jpeg', title: '8.jpeg' },
    { id: 9, type: 'image', url: 'assets/projects/PermanentAddress/9.jpg', title: '9.jpg' },
    { id: 10, type: 'image', url: 'assets/projects/PermanentAddress/10.jpg', title: '10.jpg' },
    { id: 11, type: 'image', url: 'assets/projects/PermanentAddress/11.jpg', title: '11.jpg' },
    { id: 12, type: 'image', url: 'assets/projects/PermanentAddress/12.jpg', title: '12.jpg' },
    { id: 13, type: 'image', url: 'assets/projects/PermanentAddress/13.jpg', title: '13.jpg' },
    { id: 14, type: 'image', url: 'assets/projects/PermanentAddress/14.jpg', title: '14.jpg' },
    { id: 15, type: 'image', url: 'assets/projects/PermanentAddress/15.jpg', title: '15.jpg' },
    { id: 16, type: 'image', url: 'assets/projects/PermanentAddress/16.jpg', title: '16.jpg' },
    { id: 17, type: 'image', url: 'assets/projects/PermanentAddress/17.jpg', title: '17.jpg' },
    { id: 18, type: 'image', url: 'assets/projects/PermanentAddress/18.jpg', title: '18.jpg' },
    { id: 19, type: 'image', url: 'assets/projects/PermanentAddress/19.jpeg', title: '19.jpeg' },
    { id: 20, type: 'image', url: 'assets/projects/PermanentAddress/20.jpg', title: '20.jpg' },
    { id: 21, type: 'image', url: 'assets/projects/PermanentAddress/21.jpg', title: '21.jpg' },
    { id: 22, type: 'image', url: 'assets/projects/PermanentAddress/22.jpg', title: '22.jpg' },
    { id: 23, type: 'image', url: 'assets/projects/PermanentAddress/23.jpg', title: '23.jpg' },
    { id: 24, type: 'image', url: 'assets/projects/PermanentAddress/24.jpg', title: '24.jpg' },
    { id: 25, type: 'image', url: 'assets/projects/PermanentAddress/25.jpg', title: '25.jpg' },
    { id: 26, type: 'image', url: 'assets/projects/PermanentAddress/26.jpg', title: '26.jpg' },
    { id: 27, type: 'image', url: 'assets/projects/PermanentAddress/27.jpg', title: '27.jpg' },
    { id: 28, type: 'image', url: 'assets/projects/PermanentAddress/28.jpeg', title: '28.jpeg' },
    { id: 29, type: 'image', url: 'assets/projects/PermanentAddress/29.jpg', title: '29.jpg' },
    { id: 30, type: 'image', url: 'assets/projects/PermanentAddress/30.jpg', title: '30.jpg' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
